import Navigation from "../../components/NavbarComps";
import Footer from "../../components/FooterComps";
import '../../assets/css/Registration.css'

function HomeRegist() {
  return (
    <>
      <Navigation />
      <section className="homeregist-section">
        <div>
          <div className="wrapper">
            <div className="text-center">
              <h1 className="mx-auto text-sm md:text-lg lg:text-5xl">
                REGISTRATION FORM
              </h1>
              <h3 className="mx-auto mt-5 mb-2 text-sm md:text-lg lg:text-2xl">
                Choose Categories Participant for Registration BISF 2026
              </h3>
            </div>
          </div>
          <div className="link-web mx-auto text-center">
            {/* <a className="btn btn-action text-center me-lg-5" href="/homeindo">
              Indonesian Citizen{" "}<i className="fa-solid fa-earth-americas"></i>
            </a>
            <a className="btn btn-action text-center me-lg-5" href="/homeinter">
              International Citizen{" "}<i className="fa-solid fa-earth-americas"></i>
            </a> */}
            <button className="btn btn-action text-center me-lg-5" type="button">
              Close Registration{" "}<i className="fa-solid fa-earth-americas"></i>
            </button>
            <button className="btn btn-action text-center me-lg-5" type="button">
              Close Registration{" "}<i className="fa-solid fa-earth-americas"></i>
            </button>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}

export default HomeRegist;
